(() => {
  function build(product, canonical, conditional = false, now = Date.now()) {
    if (!product || conditional) return null;
    const start = Date.parse(product.fetchedAt), end = Date.parse(product.expiresAt);
    if (!Number.isFinite(start) || !Number.isFinite(end) || start > now + 60000 || end <= now || end <= start || end - start > 86400000) return null;
    if (!/^[A-Z0-9]{10}$/.test(product.asin || '') || !String(product.title || '').trim()) return null;
    const raw = String(product.price ?? '');
    if (!/^\d+(?:\.\d{1,2})?$/.test(raw) || Number(raw) <= 0 || !Number.isFinite(Number(raw))) return null;
    if (product.currency && product.currency !== 'USD') return null;
    if (/SUBSCRIBE|SUBSCRIPTION|PRIME/i.test([product.offerType, product.deal?.accessType].join(' '))) return null;
    if (!['IN_STOCK','IN_STOCK_SCARCE','INSTOCK','INSTOCKSCARCE'].includes(product.availabilityType)) return null;
    for (const [field, future] of [['startTime', true], ['endTime', false]]) {
      if (!product.deal?.[field]) continue;
      const time = Date.parse(product.deal[field]);
      if (!Number.isFinite(time) || (future ? time > now : time <= now)) return null;
    }
    let destination, page;
    try {
      destination = new URL(product.affiliateUrl); page = new URL(canonical);
      if (destination.protocol !== 'https:' || !['amazon.com', 'www.amazon.com'].includes(destination.hostname)) return null;
      if (page.protocol !== 'https:' || !['bizedeals.com', 'www.bizedeals.com'].includes(page.hostname) || !page.pathname.startsWith('/products/')) return null;
    } catch { return null; }
    page.search = ''; page.hash = '';
    const images = (product.images || []).filter(src => {
      try { const u = new URL(src); return u.protocol === 'https:' && u.hostname === 'm.media-amazon.com'; } catch { return false; }
    }).slice(0, 3);
    if (!images.length) return null;
    const offer = {'@type':'Offer', url:page.href, price:Number(raw).toFixed(2), priceCurrency:'USD', validThrough:new Date(Math.min(end, Date.parse(product.deal?.endTime) || end)).toISOString()};
    offer.availability = 'https://schema.org/InStock';
    const result = {'@context':'https://schema.org','@type':'Product','@id':page.href+'#product',name:String(product.title).trim(),url:page.href,image:images,productID:'asin:'+product.asin,offers:offer};
    if (String(product.brand || '').trim()) result.brand = {'@type':'Brand',name:String(product.brand).trim()};
    return result;
  }
  function sync(root, product, conditional) {
    let script = root.querySelector('[data-product-jsonld]');
    const value = build(product, root.dataset.canonicalUrl, conditional);
    if (!value) { script?.remove(); return; }
    if (!script) { script = document.createElement('script'); script.type = 'application/ld+json'; script.dataset.productJsonld = ''; root.append(script); }
    const text = JSON.stringify(value);
    if (script.textContent !== text) script.textContent = text;
  }
  window.BizedealsProductSchema = {build, sync};
})();
